angular.module('impactx.rfq').controller('RFQContractSelectionCtrl', RFQContractSelectionCtrl);

RFQContractSelectionCtrl.$inject = ['$scope', '$mdDialog', 'themeFactory', 'AppConfiguration', 'dataGen', 'TranslationService'];

function RFQContractSelectionCtrl($scope, $mdDialog, themeFactory, AppConfiguration, dataGen, TranslationService) {
    var ctrl = this;

    $scope.theme = themeFactory.getTheme();

    $scope.requestInProgress = true;

    var getData = function() {
        dataGen.getData($scope, {}, "/rfq/contractselection").then(function () {
            $scope.trns.forward = TranslationService.get('forward');
            $scope.trns.abort = TranslationService.get('abort');
            $scope.requestInProgress = false;
        });
    }

    ctrl.freeformOfferLotSelect = AppConfiguration.get('freeformOfferLotSelect');

    $scope.supplierAndContractArray = [];
    $scope.supplierAndLotArray = [];

    $scope.supplierControl = {};
    $scope.lotAndContractControl = {};

    var resetSelectArray = function () {
        $scope.supplierAndContractArray = [];
        $scope.supplierAndLotArray = [];
    };
    resetSelectArray();

    ctrl.supplierSelected = function (selected) {
        resetSelectArray();
        $scope.supplierAndContractArray.push({field: 'supplierId', value: selected ? selected.id : 0});
        $scope.supplierAndContractArray.push({
            field: 'contractId',
            value: $scope.data.contract.selected ? $scope.data.contract.selected.id : 0
        });
        if (!$scope.data.contract.selected && selected) {
            $scope.lotAndContractControl.getEntries($scope.supplierAndContractArray, true);
        }
    };

    ctrl.contractSelected = function (selected) {
        resetSelectArray();
        if (!$scope.supplierId) {
            $scope.supplierAndContractArray.push({
                field: 'supplierId',
                value: $scope.data.supplier.selected ? $scope.data.supplier.selected.id : 0
            });
        }
        $scope.supplierAndContractArray.push({field: 'contractId', value: selected ? selected.id : 0});
        if (!$scope.data.supplier.selected && selected) {
            $scope.supplierControl.getEntries($scope.supplierAndContractArray, true);
        }
    };

    ctrl.lotSelected = function (selected) {
        resetSelectArray();
        if (!$scope.supplierId) {
            $scope.supplierAndLotArray.push({
                field: 'supplierId',
                value: $scope.data.supplier.selected ? $scope.data.supplier.selected.id : 0
            });
        }
        $scope.supplierAndLotArray.push({field: 'lotId', value: selected ? selected.id : 0});
        if (!$scope.data.supplier.selected && selected) {
            $scope.supplierControl.getEntries($scope.supplierAndLotArray, true);
        }
    };

    ctrl.supplierForLotSelected = function (selected) {
        resetSelectArray();
        $scope.supplierAndLotArray.push({field: 'supplierId', value: selected ? selected.id : 0});
        if (!$scope.lotId) {
            $scope.supplierAndLotArray.push({
                field: 'lotId',
                value: $scope.data.lot.selected ? $scope.data.lot.selected.id : 0
            });
        }
        if (!$scope.data.lot.selected && selected) {
            $scope.lotAndContractControl.getEntries($scope.supplierAndLotArray, true);
        }
    };

    ctrl.save = function () {
        var result = {
            supplierId: $scope.data.supplier.selected.id,
            cscId: impactX.isDefined($scope, 'data.contract.selected.id'),
            lotId: impactX.isDefined($scope, 'data.lot.selected.id')
        };
        $mdDialog.hide(result);
    };

    ctrl.abort = function () {
        $mdDialog.cancel();
    }

    getData();
}